import {useParams} from 'react-router-dom'
import {useRoleUser} from './useRoleUser'
import {SI_STATUS} from 'src/constants'

type TSIP =
  | 'all'
  | 'reject'
  | 'amandement'
  | 'outstanding'
  | 'revision'
  | 'finish'
  | 'monitoring'
  | 'process'

/**
 * Hook ini menampilkan daftar status untuk SIP berdasarkan
 * tipe SIP ['all'|'reject'|'amendement'|'outstanding'|'revision'] dan role user.
 * Untuk mengambil tipenya menggunakan useParam dari react-router-dom
 */
export const useSIPStatus = () => {
  const {isSalesAnper, isSalesAdmin} = useRoleUser()
  const params = useParams<{type: TSIP}>()

  const isAll = params.type === 'all'
  const isReject = params.type === 'reject'
  const isAmandement = params.type === 'amandement'
  const isOutStanding = params.type === 'outstanding'
  const isRevision = params.type === 'revision'
  const isFinish = params.type === 'finish'
  const isMonitoring = params.type === 'monitoring'
  const isProcessSIP = params.type === 'process'

  /**
   * Jika role user "ANPER" dan param type-nya "all" maka statusnya adalah:
   * - Dikirimkan (4)
   * - Diterima (5)
   * - Proses Realisasi Anper (6)
   * - Proses Realisasi Customer (7)
   * - Selesai (8)
   * - Amandemen (9)
   */
  if (isSalesAnper && isAll) {
    return SI_STATUS.filter(
      (item) =>
        item.value === '4' ||
        item.value === '5' ||
        item.value === '6' ||
        item.value === '7' ||
        item.value === '9' ||
        item.value === '11'
    )
  }

  /**
   * Jika role user "PI (Sales Admin)" dan param type-nya "all" maka status adalah:
   * - semua status
   */
  if (isSalesAdmin && isAll) {
    return SI_STATUS
  }

  /**
   * TODO: Jika role user "ANPER" dan param type-nya "finish" maka status adalah:
   * - selesai (8)
   */
  if (isSalesAnper && isFinish) {
    return SI_STATUS.filter((item) => item.value === '11')
  }

  /**
   * TODO: Jika role user "PI" dan param type-nya "finish" maka status adalah:
   * - selesai (8)
   */
  if (isSalesAdmin && isFinish) {
    return SI_STATUS.filter((item) => item.value === '11')
  }

  /**
   * TODO: Jika role user "ANPER" dan param type-nya "monitoring" maka status adalah:
   * - Proses Realises Customer (7)
   */
  if (isSalesAnper && isMonitoring) {
    return SI_STATUS.filter((item) => item.value === '7')
  }

  /**
   * TODO: Jika role user "PI" dan param type-nya "monitoring" maka status adalah:
   * - Dikirimkan (4)
   * - Diterima (5)
   * - Proses Realisasi Anper (6)
   * - Proses Realisasi Customer (7)
   */
  if (isSalesAdmin && isMonitoring) {
    return SI_STATUS.filter(
      (item) => item.value === '4' || item.value === '5' || item.value == '6' || item.value === '7'
    )
  }

  /**
   * Jika role user "ANPER" dan param type-nya "reject" maka status adalah:
   * - tidak ada status
   */
  if (isSalesAnper && isReject) {
    return []
  }

  /**
   * Jika role user "PI" dan param type-nya "reject" maka status adalah:
   * - Ditolak (99)
   */
  if (isSalesAnper && isReject) {
    return SI_STATUS.filter((item) => item.value === '99')
  }

  /**
   * TODO: Jika role user "ANPER" dan param type-nya "process_sip" maka status adalah:
   * - Dikirimkan (4)
   * - Diterima (5)
   * - Proses Realisasi Anper (6)
   * - Amandemen (9)
   */
  if (isSalesAnper && isProcessSIP) {
    return SI_STATUS.filter(
      (item) => item.value === '4' || item.value === '5' || item.value === '6' || item.value === '9'
    )
  }

  /**
   * TODO: Jika role user "PI" dan param type-nya "process_sip" maka status adalah:
   * - Menunggu (1)
   * - Revisi (2)
   * - Proses Persetujuan (3)
   * - Amandemen (9)
   */
  if (isSalesAdmin && isProcessSIP) {
    return SI_STATUS.filter(
      (item) =>
        item.value === '1' ||
        item.value === '2' ||
        item.value === '3' ||
        item.value === '9' ||
        item.value === '10'
    )
  }

  return SI_STATUS
}
